const init = (): void => {
	if (!Array.isArray(window.dataLayer)) {
		window.dataLayer = [];
	}
};
/**
 * @description Legacy method to track events. gtag(...) preferred according to google docs.
 */
const trackEvent = (event: Record<string, unknown>): void => {
	init();
	window.dataLayer?.push(event);
};

const track = (
	command: string,
	eventName: string,
	params: Record<string, unknown>
): void => {
	init();
	window.dataLayer?.push([command, eventName, params]);
};

export const gtag = Object.assign(track, {
	trackEvent,
});
